// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import Chapter from "src/components/base/chapter/Chapter";

// Sub-Components
import GameCard from "./GameCard";

// Data / Images / Icons
import {
  GAMES,
  GAME_SYSTEMS,
  GAME_TEMPLATES,
  MODELS_3D,
} from "src/data/pages/games";

function GameCardGroup() {
  return (
    <div>
      {/* Games */}
      <Chapter text="Games">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GAMES.map((game, index) => (
            <GameCard key={`game-${index}`} game={game} />
          ))}
        </div>
      </Chapter>

      {/* Game Systems */}
      <Chapter text="Game Systems">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GAME_SYSTEMS.map((game, index) => (
            <GameCard key={`game-${index}`} game={game} />
          ))}
        </div>
      </Chapter>

      {/* Game Templates */}
      <Chapter text="Game Templates">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GAME_TEMPLATES.map((game, index) => (
            <GameCard key={`game-${index}`} game={game} />
          ))}
        </div>
      </Chapter>

      {/* Models 3D */}
      <Chapter text="Models 3D">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MODELS_3D.map((game, index) => (
            <GameCard key={`game-${index}`} game={game} />
          ))}
        </div>
      </Chapter>
    </div>
  );
}

export default GameCardGroup;
